import angular from 'angular';
import template from './webcam-blocked-chrome.html';
import './webcam-blocked-chrome.scss';
class WebcamBlockedChromeController {
    constructor() { }
    $onInit() { }
}
const webcamBlockedChrome = {
    template,
    bindings: {},
    controller: WebcamBlockedChromeController,
};
export default angular
    .module('doxy.videoChat.userMediaStatus.common.components.webcamMessageBlocked', [])
    // webcam-blocked-chrome
    .component('webcamBlockedChrome', webcamBlockedChrome).name;
